import { db, firestorage } from "../Config";

export const saveCites = (citas) => {
  return new Promise((resolve, reject) => {
    if (!citas.empresaId) {
      return reject(new Error("empresaId is required to save a cita"));
    }
    const citasRef = db.collection("empresas").doc(citas.empresaId).collection("citas").doc();
    citas.id = citasRef.id;

    citasRef
      .set(citas)
      .then(() => {
        resolve({ id: citasRef.id, ...citas });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateCiteById = (id, empresaId, cites) => {
  return new Promise((resolve, reject) => {
    if (!empresaId) return reject(new Error("empresaId is required"));
    const citasRef = db.collection("empresas").doc(empresaId).collection("citas").doc(id);
    citasRef
      .update(cites)
      .then(() => {
        resolve({ id, ...cites });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteCiteById = (id, empresaId) => {
  return new Promise((resolve, reject) => {
    if (!empresaId) return reject(new Error("empresaId is required"));
    const citasRef = db.collection("empresas").doc(empresaId).collection("citas").doc(id);
    citasRef
      .delete()
      .then(() => resolve({ id, message: "Cita eliminada correctamente" }))
      .catch((err) => reject(err));
  });
};


export const getCitesByBusinessId = (empresaId) => {
  return new Promise((resolve, reject) => {
    if (!empresaId) return reject(new Error("empresaId is required"));
    db.collection("empresas")
      .doc(empresaId)
      .collection("citas")
      .where("empresaId", "==", empresaId)
      .get()
      .then((querySnapshot) => {
        const cites = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        resolve(cites);
      })
      .catch((err) => reject(err));
  });
};

export const getCitasCountByEmpresaMonth = async (currentDate, empresaId) => {
  if (!empresaId || !currentDate) return 0;
  // Get first and last day of current month
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0, 23, 59, 59, 999);
  try {
    const snapshot = await db.collection("empresas")
      .doc(empresaId)
      .collection("citas")
      .where("empresaId", "==", empresaId)
      .where("start.dateTime", ">=", firstDay.toISOString())
      .where("start.dateTime", "<=", lastDay.toISOString())
      .get();
    return snapshot.size;
  } catch (error) {
    console.error("Error getting movimientos count:", error);
    return 0;
  }
};
